import { NavLink, Outlet } from "react-router-dom";
import {
  Bell,
  Mail,
  Monitor,
  Settings2,
  ShieldCheck,
  Trash2,
  User,
} from "lucide-react";
import { PageHeader } from "@/components/v2/PageHeader";

/**
 * `/account/*` — user-scoped settings. Mirrors the operator's identity
 * across workspaces; everything here lives on the `users` table and
 * follows the human when they switch workspaces.
 *
 * Two-column shell: left rail with one entry per leaf, right pane via
 * `<Outlet />`. Routes mounted in `App.tsx`.
 */

const TABS = [
  { to: "/account/profile", icon: User, label: "Profile" },
  { to: "/account/email", icon: Mail, label: "Email" },
  { to: "/account/security", icon: ShieldCheck, label: "Security" },
  { to: "/account/sessions", icon: Monitor, label: "Sessions" },
  { to: "/account/preferences", icon: Settings2, label: "Preferences" },
  { to: "/account/notifications", icon: Bell, label: "Notifications" },
  { to: "/account/danger-zone", icon: Trash2, label: "Danger zone" },
];

export function AccountLayout() {
  return (
    <div className="px-6 py-6 space-y-6">
      <PageHeader
        title="Account"
        subtitle="Your personal profile, security, and preferences."
      />

      <div className="grid gap-6 md:grid-cols-[220px_1fr]">
        <nav className="space-y-0.5">
          {TABS.map((t) => {
            const Icon = t.icon;
            return (
              <NavLink
                key={t.to}
                to={t.to}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-2 rounded-md text-sm transition-colors ${
                    isActive
                      ? "bg-primary text-primary-foreground"
                      : "text-foreground hover:bg-muted/60"
                  }`
                }
              >
                <Icon className="h-4 w-4 shrink-0" />
                <span>{t.label}</span>
              </NavLink>
            );
          })}
        </nav>

        <main className="min-w-0">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
